import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
const SafeAreaProvider = ({ children }) => {
    return _jsx(_Fragment, { children: children });
};
export default SafeAreaProvider;
